"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.toOperationExtraRaw = exports.fromOperationExtraRaw = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
function fromOperationExtraRaw(extra) {
    if (!extra)
        return extra;
    var gasLimit = extra.gasLimit, gasPremium = extra.gasPremium, gasFeeCap = extra.gasFeeCap;
    if (gasLimit !== undefined)
        extra = __assign(__assign({}, extra), { gasLimit: new bignumber_js_1["default"](gasLimit) });
    if (gasPremium !== undefined)
        extra = __assign(__assign({}, extra), { gasPremium: new bignumber_js_1["default"](gasPremium) });
    if (gasFeeCap !== undefined)
        extra = __assign(__assign({}, extra), { gasFeeCap: new bignumber_js_1["default"](gasFeeCap) });
    return extra;
}
exports.fromOperationExtraRaw = fromOperationExtraRaw;
function toOperationExtraRaw(extra) {
    if (!extra)
        return extra;
    var gasLimit = extra.gasLimit, gasPremium = extra.gasPremium, gasFeeCap = extra.gasFeeCap;
    if (gasLimit !== undefined)
        extra = __assign(__assign({}, extra), { gasLimit: gasLimit.toNumber() });
    if (gasPremium !== undefined)
        extra = __assign(__assign({}, extra), { gasPremium: gasPremium.toFixed() });
    if (gasFeeCap !== undefined)
        extra = __assign(__assign({}, extra), { gasFeeCap: gasFeeCap.toFixed() });
    return extra;
}
exports.toOperationExtraRaw = toOperationExtraRaw;
exports["default"] = {
    fromOperationExtraRaw: fromOperationExtraRaw,
    toOperationExtraRaw: toOperationExtraRaw
};
//# sourceMappingURL=account.js.map